import { render, staticRenderFns } from "./NavWeekRow.vue?vue&type=template&id=5dedae43&scoped=true&"
import script from "./NavWeekRow.vue?vue&type=script&lang=js&"
export * from "./NavWeekRow.vue?vue&type=script&lang=js&"
import style0 from "./NavWeekRow.vue?vue&type=style&index=0&id=5dedae43&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dedae43",
  null
  
)

export default component.exports